import ads from '@assets/ads'
import { SponsorBanner } from '@components/sponsor-banner'
import classnames from 'classnames'
import React, { useEffect } from 'react'
import { Article } from 'types/article'
import { ArticlePreview } from '../article-preview'

import styles from './styles.module.scss'

interface AuthorArticlesList {
  articles: Article[]
  position?: number
  showSponsor?: boolean
  className?: string
}

export const AuthorArticlesList = ({
  articles,
  showSponsor,
  className
}: AuthorArticlesList) => {
  useEffect(() => {
    const adNames = Object.keys(ads)
    adNames.map(name => (ads[name].used = false))
  })
  return (
    <div className={classnames(className, styles.listContainer)}>
      {articles.map((article, index) => (
        <React.Fragment key={index.toString()}>
          <ArticlePreview
            key={article.id}
            className={styles.borderBottom}
            articlePath={article.path}
            title={article.title}
            description={article.shortContent}
            date={new Date(article.publishedAt).toLocaleDateString('pt-BR')}
            readingTime={`${article.timeToRead} min de leitura`}
            editorial={
              article.editorialAscendent
                ? article.editorialAscendent.name
                : article.editorial.name
            }
            editorialPath={
              article.editorialAscendent
                ? article.editorialAscendent.path
                : article.editorial.path
            }
            videoUrl={article.videoUrl}
            articleType={article.articleType}
          />
          {(index + 1) % 8 === 0 && showSponsor && <SponsorBanner />}
        </React.Fragment>
      ))}
    </div>
  )
}
